import React from 'react';
import { ExternalLink, ShieldCheck } from 'lucide-react';
import { Card } from './ui/Card';
interface ToolCardProps {
  name: string;
  description: string;
  url: string;
  safetyNote: string;
}
export function ToolCard({
  name,
  description,
  url,
  safetyNote
}: ToolCardProps) {
  return <Card hoverEffect className="p-4 sm:p-6 flex flex-col h-full" data-id="element-632">
      {/* Header - Mobile Optimized */}
      <div className="flex items-start justify-between mb-3 sm:mb-4 gap-2" data-id="element-633">
        <h3 className="text-base sm:text-lg font-bold text-slate-100 break-words flex-1" data-id="element-634">
          {name}
        </h3>
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyan-500 transition-colors flex-shrink-0 min-w-[44px] min-h-[44px] flex items-center justify-center -m-2" aria-label={`Visit ${name}`} data-id="element-635">
          <ExternalLink className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-636" />
        </a>
      </div>

      {/* Description - Mobile Optimized */}
      <p className="text-slate-400 text-xs sm:text-sm mb-4 sm:mb-6 flex-grow break-words" data-id="element-637">
        {description}
      </p>

      {/* Safety Badge - Mobile Optimized */}
      <div className="mt-auto flex items-center text-xs text-green-400 bg-green-400/10 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full w-fit" data-id="element-638">
        <ShieldCheck className="h-3 w-3 mr-1.5 flex-shrink-0" data-id="element-639" />
        <span className="break-words" data-id="element-640">{safetyNote}</span>
      </div>
    </Card>;
}